import React, { useEffect } from 'react';
import { classnames } from '@/libs/utils';
import { clearCacheSuffixForCurrentContent } from '@/context/TranscriptContext/TranscriptContextUtils';

const RSClipFallbackWithoutNewTimeline = ({ showLoaderOnPage }: { showLoaderOnPage: boolean }) => {
  useEffect(() => {
    clearCacheSuffixForCurrentContent();
  }, []);

  return (
    <div
      className={classnames(
        'flex size-full items-center justify-center bg-gray-50 text-gray-600',
        showLoaderOnPage ? 'fixed inset-0' : ''
      )}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="flex items-center justify-center">
          <svg
            className="size-8 animate-spin text-orange-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <p className="ml-4 text-lg font-medium">Hold tight! We're getting your video ready.</p>
        </div>
      </div>
    </div>
  );
};

export default RSClipFallbackWithoutNewTimeline;
